import type { ReactNode } from 'react'

export type UnderlineTab = {
  id: string
  label: ReactNode
  badge?: ReactNode
}

type UnderlineTabNavProps = {
  tabs: UnderlineTab[]
  activeId: string
  onChange: (id: string) => void
  ariaLabel?: string
  className?: string
}

export default function UnderlineTabNav({
  tabs,
  activeId,
  onChange,
  ariaLabel,
  className = '',
}: UnderlineTabNavProps) {
  return (
    <div className={`border-b border-gray-200 ${className}`}>
      <nav
        className="flex gap-3 sm:gap-6 overflow-x-auto flex-shrink-0"
        role="tablist"
        aria-label={ariaLabel}
        data-bk-nav
      >
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={activeId === tab.id}
            onClick={() => onChange(tab.id)}
            className={`flex items-center gap-2 py-2 border-b-2 text-sm font-medium transition-colors whitespace-nowrap ${
              activeId === tab.id
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            {tab.label}
            {tab.badge}
          </button>
        ))}
      </nav>
    </div>
  )
}
